import DateFormat from '@/Enums/Format/DateFormat.enum';
import moment from 'moment';

export const Weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const getDayOfWeek = date => {
  const index = (new Date(`${date}T12:00:00Z`).getDay() || 7) - 1;
  return Weekdays[index];
};

export const enumerateDaysBetweenDates = (startDate, endDate) => {
  if (startDate.trim() === endDate.trim()) {
    return [startDate];
  }
  const dates = [];

  const currDate = moment(startDate).startOf('day');
  const lastDate = moment(endDate).startOf('day');

  while (currDate.add(1, 'days').diff(lastDate) < 0) {
    dates.push(currDate.clone().format(DateFormat.Iso8601));
  }

  return [startDate, ...dates, endDate];
};

export const isIsoDateString = dateString => {
  return typeof dateString === 'string' && dateString.includes('T');
};

export const isoDateWithoutTime = isoStringDate =>
  isIsoDateString(isoStringDate) ? isoStringDate.split('T')[0] : isoStringDate;

const SECONDS_IN_A_DAY = 86400;

export const getSecondsInDays = days => Math.floor(+days * SECONDS_IN_A_DAY);
export const getDaysInSeconds = seconds => +seconds / SECONDS_IN_A_DAY;
